import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store/index'
import VueProgressBar from 'vue-progressbar'
import VueQRCodeComponent from 'vue-qrcode-component'

Vue.config.productionTip = false

const progressBarOptions = {
  color: 'green',
  failedColor: 'red',
  thickness: '5px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300
  },
  autoRevert: true,
  location: 'top',
  inverse: false
}

Vue.use(VueProgressBar, progressBarOptions)
Vue.component('qr-code', VueQRCodeComponent)

const vm = new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')

export { vm }